import { useEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";
import NavBar from "../../Componentes/NavBar";
import SortableTable from "../../Componentes/Utils/SortableTable";
import { useModal } from "../../contexts/ModalContext";
import SidebarInventarioTI from "./SidebarInventarioTI";
import ModalNovoEquipamento from "./ModalNovoEquipamento";
import ModalAtribuirResponsavel from "./ModalAtribuirResponsavel";
import ModalNovoTipoAtivo from "./ModalNovoTipoAtivo";
import useApi from "../../hooks/useApi";

const Container = styled.div`
  width: 100%;
  height: 100dvh;
  background-color: #242d34;
  display: flex;
  flex-direction: column;
`;

const BodyWrapper = styled.div`
  width: 100%;
  flex: 1;
  padding: 15px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  gap: 12px;
`;

const HeaderBar = styled.div`
  width: 100%;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: center;
`;

const Title = styled.h2`
  margin: 0;
  color: #fff;
  font-size: 16px;
  letter-spacing: 0.5px;
`;

const Badge = styled.div`
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: rgba(255, 255, 255, 0.9);
  padding: 8px 10px;
  border-radius: 10px;
  font-size: 13px;
`;

const FilterInput = styled.input`
  height: 40px;
  flex: 1;
  min-width: 240px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  padding: 0 12px;
  box-sizing: border-box;
  outline: none;

  &::placeholder {
    color: rgba(255, 255, 255, 0.7);
  }

  &:focus {
    border-color: rgba(0, 123, 255, 0.9);
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
`;

const TableShell = styled.div`
  width: 100%;
  flex: 1;
  background-color: #ffffff;
  border-radius: 15px;
  overflow: hidden;
`;

const ActionsCell = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
`;

const KebabButton = styled.button`
  all: unset;
  cursor: pointer;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #242d34;

  &:hover {
    background: rgba(36, 45, 52, 0.08);
  }

  &:focus-visible {
    outline: 2px solid #007bff;
    outline-offset: 2px;
  }
`;

const Menu = styled.div`
  position: absolute;
  top: 38px;
  right: 0;
  width: 220px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.12);
  box-shadow: 0 12px 26px rgba(0, 0, 0, 0.18);
  border-radius: 12px;
  overflow: hidden;
  z-index: 10;
`;

const MenuItem = styled.button`
  all: unset;
  display: flex;
  width: 100%;
  padding: 12px 12px;
  box-sizing: border-box;
  cursor: pointer;
  color: #242d34;
  font-size: 13px;

  &:hover {
    background: #e8f0fe;
  }
`;

const DangerItem = styled(MenuItem)`
  color: #b91c1c;
  &:hover {
    background: rgba(185, 28, 28, 0.08);
  }
`;

// Rotas fictícias (backend você vai criar)
const INVENTARIO_API = {
  tipos: "/Painel/API/InventarioTI/tipo_ativo/index.php",
  criarTipo: "/Painel/API/InventarioTI/tipo_ativo/create.php",
  ativos: "/Painel/API/InventarioTI/ativo/index.php",
  criarAtivo: "/Painel/API/InventarioTI/ativo/create.php",
  desativarAtivo: "/Painel/API/InventarioTI/ativo/desativar.php",
  /** Lista unificada (JOIN ativos + tipo_ativo + colabs_atv ativa) — mesma query do backend */
  listaTabela: "/Painel/API/InventarioTI/GetAtivos/",
  atribuir: "/Painel/API/InventarioTI/colabs_atv/atribuir.php",
  remover: "/Painel/API/InventarioTI/colabs_atv/remover.php",
};

export default function InventarioTI() {
  const { openModal, isModalOpen, closeModal } = useModal();
  const api = useApi();

  const [loading, setLoading] = useState(true);
  const [tiposAtivo, setTiposAtivo] = useState([]);
  /** Linhas retornadas pelo GET (id, descricao, patrimonio, num_serie, tipo, matricula, data_inicio) */
  const [rowsTabela, setRowsTabela] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [q, setQ] = useState("");
  const [openMenuId, setOpenMenuId] = useState(null);

  const menuRef = useRef(null);

  useEffect(() => {
    function onDocClick(e) {
      if (!openMenuId) return;
      if (menuRef.current && menuRef.current.contains(e.target)) return;
      setOpenMenuId(null);
    }
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [openMenuId]);

  const requestDados = async () => {
    setLoading(true);
    try {
      const { data } = await api.get(INVENTARIO_API.listaTabela);
      console.log( data );
      
      const list = Array.isArray(data) ? data : data?.data ?? data?.rows ?? [];
      setRowsTabela(Array.isArray(list) ? list : []);
    } catch (error) {
      console.error(error);
      alert("Erro ao carregar inventário.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    requestDados();
    //requestTiposParaModais();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const equipamentos = useMemo(() => {
    return (rowsTabela ?? []).map((r) => {
      const id = String(r.id ?? "");
      const numSerie = r.num_serie ?? r.numSerie ?? "";
      return {
        id,
        tipo: r.tipo ?? "—",
        descricao: r.descricao ?? "—",
        patrimonio: r.patrimonio ?? "—",
        serial: numSerie ? String(numSerie) : "—",
        responsavel:
          r.matricula != null && String(r.matricula).trim() !== ""
            ? String(r.matricula).trim()
            : "—",
        data_inicio: r.data_inicio ?? r.dataInicio ?? null,
        data_inicio_label: r.data_inicio ?? "—",
        _raw: r,
      };
    });
  }, [rowsTabela]);

  const selectedEquipamento = useMemo(
    () => equipamentos.find((e) => e.id === selectedId) ?? null,
    [equipamentos, selectedId]
  );

  const filtered = useMemo(() => {
    const query = q.trim().toUpperCase();
    if (!query) return equipamentos;
    return equipamentos.filter((e) => {
      const hay = [
        e.id,
        e.tipo,
        e.descricao,
        e.patrimonio,
        e.serial,
        e.responsavel,
        e.data_inicio_label,
      ]
        .filter(Boolean)
        .join(" ")
        .toUpperCase();
      return hay.includes(query);
    });
  }, [equipamentos, q]);

  const handleOpenSidebar = () => openModal("sidebarInventarioTI");

  const handleRemoveResponsavel = async (equipamentoId) => {
    try {
      await api.post(INVENTARIO_API.remover, { id_ativo: equipamentoId });
      await requestDados();
      setSelectedId(equipamentoId);
    } catch (err) {
      console.error(err);
      alert("Erro ao remover responsável do equipamento.");
    }
  };

  const handleDesativar = async (equipamentoId) => {
    try {
      await api.post(INVENTARIO_API.desativarAtivo, { id_ativo: equipamentoId });
      await requestDados();
      setSelectedId(equipamentoId);
    } catch (err) {
      console.error(err);
      alert("Erro ao desativar equipamento.");
    }
  };

  const [equipamentoIdParaResponsavel, setEquipamentoIdParaResponsavel] = useState("");

  const columns = useMemo(
    () => [
      { id: "id", header: "ID", accessor: (r) => r.id, width: "90px" },
      { id: "tipo", header: "TIPO", accessor: (r) => r.tipo, width: "120px" },
      { id: "descricao", header: "EQUIPAMENTO", accessor: (r) => r.descricao, width: "320px" },
      { id: "patrimonio", header: "PATRIMÔNIO", accessor: (r) => r.patrimonio, width: "130px" },
      { id: "serial", header: "Nº SÉRIE", accessor: (r) => r.serial, width: "140px" },
      { id: "responsavel", header: "MATRÍCULA", accessor: (r) => r.responsavel, width: "120px" },
      {
        id: "data_inicio",
        header: "DATA INÍCIO",
        accessor: (r) => r.data_inicio_label,
        sortValue: (r) => r.data_inicio ?? "",
        width: "130px",
      },
      {
        id: "acoes",
        header: "",
        accessor: () => null,
        sortable: false,
        width: "60px",
        align: "center",
        render: (_v, row) => (
          <ActionsCell
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <KebabButton
              type="button"
              title="Ações"
              aria-label={`Ações do equipamento ${row.id}`}
              onClick={(e) => {
                e.stopPropagation();
                setSelectedId(row.id);
                setOpenMenuId((prev) => (prev === row.id ? null : row.id));
              }}
            >
              ⋯
            </KebabButton>

            {openMenuId === row.id && (
              <Menu
                ref={menuRef}
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <MenuItem
                  type="button"
                  onClick={() => {
                    setOpenMenuId(null);
                    setEquipamentoIdParaResponsavel(row.id);
                    openModal("modalAtribuirResponsavelTI");
                  }}
                >
                  Atribuir responsável
                </MenuItem>
                <MenuItem
                  type="button"
                  onClick={() => {
                    setOpenMenuId(null);
                    handleRemoveResponsavel(row.id);
                  }}
                >
                  Remover responsável
                </MenuItem>
                <DangerItem
                  type="button"
                  onClick={() => {
                    const ok = window.confirm("Desativar este equipamento?");
                    if (!ok) return;
                    setOpenMenuId(null);
                    handleDesativar(row.id);
                  }}
                >
                  Desativar equipamento
                </DangerItem>
              </Menu>
            )}
          </ActionsCell>
        ),
      },
    ],
    [handleDesativar, handleRemoveResponsavel, openMenuId, openModal]
  );

  return (
    <>
      <Container>
        <NavBar title="INVENTÁRIO T.I." setSideBar={handleOpenSidebar} />
        <BodyWrapper>
          <HeaderBar>
            <Title>Equipamentos</Title>
            <Badge>Total: {equipamentos.length}</Badge>
            <Badge>Selecionado: {selectedEquipamento ? `${selectedEquipamento.id}` : "—"}</Badge>
            <FilterInput
              placeholder="Pesquisar por patrimônio, serial, equipamento, responsável..."
              value={q}
              onChange={(e) => setQ(e.target.value)}
            />
          </HeaderBar>

          <TableShell>
            <SortableTable
              columns={columns}
              data={filtered}
              isLoading={loading}
              loadingText="Carregando inventário..."
              onRowClick={(row) => setSelectedId(row.id)}
              rowCursor="pointer"
              emptyText="NENHUM EQUIPAMENTO ENCONTRADO"
              initialSort={{ key: "descricao", direction: "asc" }}
            />
          </TableShell>
        </BodyWrapper>
      </Container>

      {isModalOpen("sidebarInventarioTI") && (
        <SidebarInventarioTI
          selectedEquipamento={selectedEquipamento}
          onClose={() => closeModal()}
          onNovoEquipamento={() => openModal("modalNovoEquipamentoTI")}
          onNovoTipoAtivo={() => openModal("modalNovoTipoAtivoTI")}
        />
      )}

      {isModalOpen("modalNovoEquipamentoTI") && (
        <ModalNovoEquipamento
          onClose={() => closeModal()}
          onCreated={requestDados}
          tiposAtivo={tiposAtivo}
        />
      )}

      {isModalOpen("modalAtribuirResponsavelTI") && (
        <ModalAtribuirResponsavel
          onClose={() => {
            setEquipamentoIdParaResponsavel("");
            closeModal();
          }}
          equipamentos={equipamentos}
          equipamentoId={equipamentoIdParaResponsavel || undefined}
          onAssigned={requestDados}
        />
      )}

      {isModalOpen("modalNovoTipoAtivoTI") && (
        <ModalNovoTipoAtivo
          onClose={() => closeModal()}
          onCreated={requestDados}
        />
      )}
    </>
  );
}

